import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { createHrPayroll, deleteHrPayroll, fetchHrPayroll, fetchHrPayrollDetails, fetchInvoiceDetails, fetchPayrollCalculation, updateHrPayroll, updateInvoice, updateInvoiceStatus, } from "../../../service/api";


export const getHrPayroll = createAsyncThunk(
    "payroll/getAll",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchHrPayroll(params)
            console.log("hr payroll", response)
            return response.data.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const getPayrollCalculation = createAsyncThunk(
    "payroll/getCal",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchPayrollCalculation(params)
            console.log("payroll calc", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)


export const getPayrollById = createAsyncThunk(
    "payroll/getById",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchHrPayrollDetails(params)
            console.log("payroll info", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const addHrPayroll = createAsyncThunk(
    "payroll/add",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await createHrPayroll(formValue)
            if (response.status === 201) {
                console.log("payroll", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)


export const editInvoiceStatus = createAsyncThunk(
    "payroll/editStatus",
    async (newData, { rejectWithValue }) => {
        try {
            const response = await updateInvoiceStatus(newData)
            if (response.status === 201) {
                console.log("edit status", response)
            }
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data || error.message)
        }
    }
)



export const editHrPayroll = createAsyncThunk(
    "payroll/edit",
    async (newData, { rejectWithValue }) => {
        try {
            const response = await updateHrPayroll(newData)
            if (response.status === 201) {
                console.log("edit payroll", response)
            }
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data || error.message)
        }
    }
)

export const deletePayroll = createAsyncThunk(
    "payroll/delete",
    async (newData, { rejectWithValue }) => {
        try {
            const response = await deleteHrPayroll(newData)
            console.log(response)
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data || error.message)
        }
    }
)


const payrollSlice = createSlice({
    name: "payrolls",
    initialState: {
        payrollList: [],
        payrollById: {},
        payrollOverview: {},
        payrollCalculate: {},
        isLoading: false,
        actionLoader: false,
        error: null,
        totalPage: 0,
        current: 1,
        limit: 10,
        search: "",
        payrollStatus: "",
        startDate: "",
        endDate: ""

    },
    reducers: {
        setPagination: (state, action) => {
            state.current = action.payload;
        },
        setSearchParams: (state, action) => {
            state.search = action.payload;
        },

        setStatusFilter: (state, action) => {
            state.payrollStatus = action.payload;
        },
        setDateFilter: (state, action) => {
            const { startDate, endDate } = action.payload || {}
            state.startDate = startDate;
            state.endDate = endDate;
        },
    },

    extraReducers: (builder) => {
        builder
            .addCase(getHrPayroll.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getHrPayroll.fulfilled, (state, action) => {
                state.isLoading = false;
                state.payrollList = action.payload.data;
                state.payrollOverview = action.payload.payrollOverview
                state.totalPage = action.payload.totalPage
            })
            .addCase(getHrPayroll.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

            // GET
            .addCase(getPayrollCalculation.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getPayrollCalculation.fulfilled, (state, action) => {
                state.isLoading = false;
                state.payrollCalculate = action.payload.data;
            })
            .addCase(getPayrollCalculation.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

            //BY ID
            .addCase(getPayrollById.pending, (state) => {
                state.error = null
            })
            .addCase(getPayrollById.fulfilled, (state, action) => {
                state.payrollById = action.payload.data;
            })
            .addCase(getPayrollById.rejected, (state, action) => {
                state.error = action.payload
            })

            // POST
            .addCase(addHrPayroll.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(addHrPayroll.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(addHrPayroll.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })

            // PUT
            .addCase(editHrPayroll.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(editHrPayroll.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(editHrPayroll.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })
            // PUT
            .addCase(editInvoiceStatus.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(editInvoiceStatus.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(editInvoiceStatus.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })

            // delete
            .addCase(deletePayroll.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(deletePayroll.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(deletePayroll.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })
    }
})
export const { setSearchParams, setPagination, setDateFilter, setStatusFilter } = payrollSlice.actions;

export default payrollSlice.reducer;